import useResidents from '../../hooks/useResidents'
import {
  Table,
  Spinner,
  Badge,
} from 'react-bootstrap'
import {
  useNavigate,
} from 'react-router-dom'
import Verified from '../../Verified';
import { formatPhone } from '../../utils';
import { format, parseISO } from 'date-fns'

const ResidentsListing = () => {
  const {
    residents,
    //refreshResidents,
    residentsLoaded,
    sortResidents,
  } = useResidents(true)
  const navigate = useNavigate()

  if (!residents || !residentsLoaded) {
    return (
      <Spinner animation="border" role="status" variant="primary" className="mb-2" />
    )
  }

  return (
    <Table striped bordered hover>
      <thead>
        <tr>
          <th><a onClick={() => sortResidents('unit')}>Unit #</a></th>
          <th>First Name</th>
          <th><a onClick={() => sortResidents('last_name')}>Last Name</a></th>
          <th>Phone</th>
          <th>Verified</th>
          <th>Status</th>
          <th>Member Since</th>
        </tr>
      </thead>

      <tbody>
        {residents.map((r) => (
          <tr key={r.id} onClick={() => navigate(`/admin/residents/${r.id}`)}>
            <td>{ r.unit }</td>
            <td>{ r.first_name }</td>
            <td>{ r.last_name }</td>
            <td><Verified verified={r.phone_verified} /> { formatPhone(r.phone) }</td>
            <td>{ r.phone_verified ? 'Yes' : 'No' }</td>
            <td>{ r.disabled ? <Badge bg="danger">Disabled</Badge> : <Badge bg="info">Active</Badge> }</td>
            <td>{ format(parseISO(r.created_at), 'LLLL do, yyyy') }</td>
          </tr>
        ))}
      </tbody>
    </Table>
  )
}

export default ResidentsListing
